import { render, staticRenderFns } from "./news-slider.vue?vue&type=template&id=94451eb0&scoped=true&"
import script from "./news-slider.vue?vue&type=script&lang=js&"
export * from "./news-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94451eb0",
  null
  
)

export default component.exports